import { render, staticRenderFns } from "./messagesPerChannel.vue?vue&type=template&id=bcfef642&scoped=true&"
import script from "./messagesPerChannel.vue?vue&type=script&lang=js&"
export * from "./messagesPerChannel.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/bs-helpers.css?vue&type=style&index=0&id=bcfef642&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfef642",
  null
  
)

export default component.exports